import { Input, Label } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { useReleaseAllDayLocked, useReleaseDayLocked } from "../hooks/useEmployee";
import { useState } from "react";

const ReleaseAllDayModal = ({ EmployeeId, toggleModal }: any) => {
  const [remark,setRemark]=useState('')
  const { mutate:ReleaseAllDaylock,isPending:isSubmitting } = useReleaseAllDayLocked();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const payload = {
    empId: EmployeeId,
    Remark:remark

    };

    ReleaseAllDaylock(payload,{
      onSuccess:()=>toggleModal(),
      onError:()=>toggleModal()
    });
    
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Label className="col-form-label">Remark</Label>
        <div className="form-input position-relative">
          <Input
            type={"text"}
            placeholder="Enter Remark"
            onChange={(event) => setRemark(event.target.value)}
            value={remark}
          />
        </div>
      </div>

      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting?"Submitting...":"Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={toggleModal}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default ReleaseAllDayModal;
